import XDialog from './Dialog';

export default {
  name: 'ElDialog',
  inheritAttrs: false,
  props: {
    width: [String, Number],
    height: [String, Number],
    visible: Boolean,
    title: String,
    modal: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    resizable: {
      type: [Boolean, Object],
      default() {
        return {
          minWidth: 200,
          minHeight: 100
        };
      }
    }
  },
  computed: {
    dialogWidth() {
      const w = this.width;
      if (!w) return undefined;
      if (typeof w === 'number') return w;
      if (w.includes('%') || w.includes('vw')) {
        return (window.innerWidth * Number.parseInt(w)) / 100;
      }
      return Number.parseInt(w);
    },
    dialogHeight() {
      const h = this.height;
      if (!h) return null;
      if (typeof h === 'number') return h;
      if (h.includes('%') || h.includes('vh')) {
        return (window.innerHeight * Number.parseInt(h)) / 100;
      }
      return Number.parseInt(h);
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
      this.$emit('closed');
    },
    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    }
  },
  render(h) {
    const { visible, dialogWidth, dialogHeight, title, modal, closeOnClickModal, resizable } = this;
    if (visible) {
      return h(
        XDialog,
        {
          ref: 'dialog',
          props: {
            ...this.$attrs,
            width: dialogWidth,
            height: dialogHeight,
            center: true,
            lighter: false,
            title,
            modal,
            closeOnClickModal,
            minimizable: false,
            resizable
          },
          on: {
            closed: this.handleClose,
            opened: e => {
              this.$emit('open', e);
              this.$emit('opened', e);
            },
            resize: e => this.$emit('resize', e),
            'resize-start': e => this.$emit('resize-start', e),
            'resize-stop': e => this.$emit('resize-stop', e),
            'size-change': e => this.$emit('size-change', e)
          },
          scopedSlots: {
            footer: this.$scopedSlots.footer ? props => this.$scopedSlots.footer() : null,
            title: this.$scopedSlots.title ? props => this.$scopedSlots.title() : null
          }
        },
        this.$slots.default
      );
    }
    return null;
  }
};
